<div class="row">
  <div class="col">
    <p>
      <strong
        >Clicking 'Submit Application' constitutes your electronic signature and
        submits your application for credit.</strong
      >
    </p>
    <!-- <p>I have reviewed and agree with the following:</p> -->

    <div
      *ngIf="!controlIsDisabled('CreditReportAuthorization')"
      class="form-check"
    >
      <input
        class="form-check-input"
        type="checkbox"
        value=""
        id="creditReportAuthorization"
        [formControl]="getFormControl('CreditReportAuthorization')"
      />
      <small>
        <label
          *ngIf="isConsumerLoanApplication; else otherStatement"
          class="form-check-label eagle-label"
          for="creditReportAuthorization"
        >
          {{ loanAuthCopy }}
        </label>
        <ng-template #otherStatement>
          <label
            class="form-check-label sims-label"
            for="creditReportAuthorization"
          >
            {{ creditAuthCopy }}
          </label>
        </ng-template>
      </small>
    </div>

    <div
      *ngIf="!controlIsDisabled('DisclaimerForOhioApplicants')"
      class="form-check"
    >
      <input
        class="form-check-input"
        type="checkbox"
        value=""
        id="disclaimerForOhioApplicants"
        [formControl]="getFormControl('DisclaimerForOhioApplicants')"
      />
      <small>
        <label class="form-check-label" for="disclaimerForOhioApplicants">
          Disclaimer for Ohio Applicants
        </label>
        <p class="text-muted">
          The Ohio laws against discrimination require that all creditors make
          credit equally available to all creditworthy customers and that credit
          reporting agencies maintain separate credit histories on each
          individual upon request. The Ohio civil rights commission administers
          compliance with this law.
        </p>
      </small>
    </div>
  </div>
</div>
